import React, { useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { styled } from "@mui/material/styles";
import { Stack, Link, Container, Typography, Card, Box } from "@mui/material";
import {
  confirmEmail,
  confirmPinCode,
  updatePassword,
} from "../../DAL/Login/Login";
import Page from "../../components/Page";
import { MHidden } from "../../components/@material-extend";
import EmailForm from "./components/EmailForm";
import PinCodeForm from "./components/PinCodeForm";
import NewPasswordForm from "./components/NewPasswordForm";
import { s3baseUrl } from "src/config/config";
import { get_page_content_localStorage } from "src/DAL/localStorage/localStorage";

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const HeaderStyle = styled("header")(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: "100%",
  display: "flex",
  alignItems: "center",
  position: "absolute",
  padding: theme.spacing(3),
  justifyContent: "space-between",
  [theme.breakpoints.up("md")]: {
    alignItems: "flex-start",
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(12, 0),
}));

export default function ForgetPassword() {
  const slug = localStorage.getItem("slug");
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [status, setStatus] = useState(0);
  const [adminEmail, setAdminEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const content_data = get_page_content_localStorage();

  const handleSubmitEmail = async (_email) => {
    setAdminEmail(_email);
    const formData = new FormData();
    formData.append("email", _email);
    const result = await confirmEmail(formData);
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      setIsLoading(false);
      setStatus(1);
    } else {
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleSubmitPinCode = async (pinCode) => {
    const formData = new FormData();
    formData.append("email", adminEmail);
    formData.append("verification_code", pinCode);
    const result = await confirmPinCode(formData);
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      setIsLoading(false);
      setStatus(2);
    } else {
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleSubmitNewPassword = async (newPassword, confirmPassword) => {
    const formData = new FormData();
    formData.append("email", adminEmail);
    formData.append("password", newPassword);
    formData.append("confirm_password", confirmPassword);
    const result = await updatePassword(formData);
    if (result.code === 200) {
      setStatus(0);
      // navigate("/login");
      navigate(slug ? `/login/${slug}` : "/login");

      enqueueSnackbar("Password Changed Successfully", { variant: "success" });
    } else {
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };
  return (
    <div
      className="whole-background"
      style={
        status === 0
          ? {
            backgroundImage: `url(${s3baseUrl + content_data?.forgot_password_page_image
              })`,
          }
          : {
            backgroundImage: `url(${s3baseUrl + content_data?.email_verification_page_image
              })`,
          }
      }
    >
      {" "}
      <RootStyle>

        <HeaderStyle>
          <RouterLink to="/">{/* <Logo /> */}</RouterLink>

          <MHidden width="smDown">


            <Typography
              variant="body2"
              sx={{
                backgroundColor: "rgb(247, 247, 247)",
                borderRadius: 1,
                px: 1.5,
                py: 0.5,
              }}
            >
              Back to Login? &nbsp;
              <Link
                underline="none"
                variant="subtitle2"
                component={RouterLink}
                to={slug ? `/login/${slug}` : "/login"}
              >
                Login
              </Link>
            </Typography>

          </MHidden>
        </HeaderStyle>

        <div className="row w-100">
          <div className="col-12 col-lg-6"></div>
          <div className="col-12 col-lg-6">
            <Container maxWidth="sm">
              <ContentStyle>
                <Card sx={{ p: 4, borderRadius: 4, boxShadow: 1, backgroundColor: 'rgb(247, 247, 247)' }}>
                  <Stack sx={{ mb: 2 }}>
                    {status === 0 ? (
                      <>
                        <Typography variant="h4" gutterBottom>
                          Forgot Password
                        </Typography>
                        <Typography sx={{ color: "text.secondary" }}>
                          Enter your Email.
                        </Typography>
                      </>
                    ) : (
                      ""
                    )}
                    {status === 1 ? (
                      <>
                        <Typography variant="h4" gutterBottom>
                          Please check your email
                        </Typography>
                        <Typography sx={{ color: "text.secondary" }}>
                          Enter PIN Code here.
                        </Typography>
                      </>
                    ) : (
                      ""
                    )}
                    {status === 2 ? (
                      <>
                        <Typography variant="h4" gutterBottom>
                          Forget Password
                        </Typography>
                        <Typography sx={{ color: "text.secondary" }}>
                          Enter your New Password.
                        </Typography>
                      </>
                    ) : (
                      ""
                    )}
                  </Stack>
                  {status === 0 ? (
                    <EmailForm
                      onhandleEmailSubmit={handleSubmitEmail}
                      setIsLoading={setIsLoading}
                      isLoading={isLoading}
                    />
                  ) : (
                    ""
                  )}
                  {status === 1 ? (
                    <PinCodeForm
                      onhandlePinCodeSubmit={handleSubmitPinCode}
                      setIsLoading={setIsLoading}
                      isLoading={isLoading}
                    />
                  ) : (
                    ""
                  )}
                  {status === 2 ? (
                    <NewPasswordForm
                      onhandleNewPasswordSubmit={handleSubmitNewPassword}
                      setIsLoading={setIsLoading}
                      isLoading={isLoading}
                    />
                  ) : (
                    ""
                  )}
                  <MHidden width="smUp">
                    <Typography variant="body2" align="center" sx={{ mt: 3 }}>
                      Back to Login?&nbsp;
                      <Link
                        variant="subtitle2"
                        component={RouterLink}
                        // to="/login"
                        to={slug ? `/login/${slug}` : "/login"}

                      >
                        Login
                      </Link>
                    </Typography>
                  </MHidden>
                </Card>
              </ContentStyle>
            </Container>
          </div>
        </div>
      </RootStyle>
    </div>
  );
}
